var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gaokao-book-list"},[_c('div',{staticClass:"module-title"},[_vm._v("图书")]),_c('div',{staticClass:"book-list-wrap"},_vm._l((_vm.handleBookList),function(series,index){return _c('div',{key:index,staticClass:"book-list"},[_vm._l((series),function(book,bookInd){return [(
            book.book_id != 10006 &&
            book.book_id != 10009 &&
            book.book_id != 10010 &&
            book.book_id != 10011 &&
            book.book_id != 10017 &&
            book.book_id != 10018
          )?_c('div',{key:bookInd,staticClass:"book-list-item"},[_c('img',{staticClass:"book-cover",attrs:{"src":book.book_ico,"alt":""}}),_c('div',{staticClass:"info"},[_c('h4',[_vm._v(_vm._s(book.book_title))]),(book.book_isbn)?_c('p',[_vm._v("ISBN："+_vm._s(book.book_isbn))]):_vm._e(),_c('p',[_vm._v("激活码："+_vm._s(book.activation_code))]),(
                (book.activation_status == 0 ||
                  book.activation_status == 2 ||
                  book.is_study_card == 1 ||
                  book.is_rx_study_card != 0) &&
                (book.book_id == 10004 ||
                  book.book_id == 10005 ||
                  book.book_id == 10006 ||
                  book.book_id == 10007 ||
                  book.book_id == 10008 ||
                  book.book_id == 10016 ||
                  book.book_id == 10021 ||
                  book.book_id == 10022)
              )?[_c('div',{staticClass:"btn btn-qxx",on:{"click":function($event){return _vm.goStudy(book)}}},[_vm._v("去学习")])]:_vm._e(),(book.activation_status == 0 && book.series == 'brdzs')?[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.resetActivation(book, series)}}},[_vm._v(" 重新激活 ")])]:_vm._e(),(
                ((book.activation_status == 2 ||
                  book.is_study_card == 1 ||
                  book.is_rx_study_card != 0) &&
                  book.series == 'brdzs') ||
                ((book.activation_status != 1 ||
                  book.is_study_card != 0 ||
                  book.is_rx_study_card != 0) &&
                  book.book_id == 10001) ||
                ((book.activation_status != 1 ||
                  book.is_study_card != 0 ||
                  book.is_rx_study_card != 0) &&
                  book.book_id == 10002) ||
                ((book.activation_status != 1 ||
                  book.is_study_card != 0 ||
                  book.is_rx_study_card != 0) &&
                  book.book_id == 10003)
              )?[_c('div',{staticClass:"btn btn-yjh"},[_vm._v("已激活")])]:_vm._e(),(
                book.activation_status == 1 &&
                book.is_study_card == 0 &&
                book.is_rx_study_card == 0
              )?[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.goActivation(book)}}},[_vm._v("激活")])]:_vm._e()],2)]):_vm._e()]})],2)}),0),_c('active-book',{ref:"ActiveBook",on:{"submitPopupData":_vm.submitPopupData}}),_c('reset-active-book',{ref:"ResetActiveBook",on:{"submitPopupData":_vm.submitPopupData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }